import React from 'react';
import Icon from 'components/AppIcon';
import Image from 'components/AppImage';

const CTASection = () => {
  return (
    <>
      {/* Main CTA Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-red-600 via-red-700 to-orange-600">
        <div className="max-w-4xl mx-auto text-center">
          <div className="space-y-8">
            <div className="inline-flex items-center space-x-3 bg-white/20 text-white px-6 py-3 rounded-full font-semibold text-sm mb-4">
              <Icon name="Users" size={20} />
              <span>Collaborons Ensemble</span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight">
              Prêt à Transformer Votre Entreprise avec Notre Équipe ?
            </h2>
            
            <p className="text-xl text-red-100 leading-relaxed max-w-3xl mx-auto">
              Découvrez comment notre équipe d'experts peut vous accompagner dans votre transformation digitale et faire de vos défis des opportunités de croissance durable.
            </p>
            
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6 pt-8">
              <button className="inline-flex items-center space-x-3 bg-white text-red-600 hover:bg-gray-50 px-8 py-4 rounded-xl font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200">
                <Icon name="MessageSquare" size={20} />
                <span>Consultation Gratuite</span>
              </button>
              
              <button className="inline-flex items-center space-x-3 border-2 border-white text-white hover:bg-white hover:text-red-600 px-8 py-4 rounded-xl font-semibold transition-all duration-200">
                <Icon name="Calendar" size={20} />
                <span>Planifier une Rencontre</span>
              </button>
            </div>

            {/* Team Contact Options */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-12">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center">
                <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <Icon name="Phone" size={24} className="text-white" />
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">Appelez-nous</h3>
                <p className="text-red-100 text-sm">+229 XX XX XX XX</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center">
                <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <Icon name="Mail" size={24} className="text-white" />
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">Écrivez-nous</h3>
                <p className="text-red-100 text-sm">contact@crfperfection.com</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center">
                <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <Icon name="MapPin" size={24} className="text-white" />
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">Visitez-nous</h3>
                <p className="text-red-100 text-sm">Cotonou, Bénin</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative bg-gradient-to-br from-gray-900/95 via-black/90 to-gray-800/95 text-white py-16 backdrop-blur-sm">
        {/* Transparent golden overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-amber-500/10 via-yellow-600/5 to-[#9B8E56]/8 pointer-events-none"></div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="space-y-4">
              <div className="flex items-center space-x-4">
                <Image
                  src="/assets/images/logo_CRF_PERFECTION_4x-1761998753526.png"
                  alt="CRF PERFECTION logo featuring interlocking heart-shaped design representing team excellence and collaborative expertise"
                  className="w-12 h-12 object-contain filter drop-shadow-lg"
                />
                <div>
                  <h3 className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-amber-300 to-yellow-400">
                    CRF PERFECTION
                  </h3>
                  <p className="text-amber-200/80 text-sm">Excellence par l'Équipe</p>
                </div>
              </div>
              <p className="text-gray-300/90 text-sm leading-relaxed">
                Une équipe d'experts passionnés qui transforme vos défis en succès durables grâce à l'innovation et l'excellence collaborative.
              </p>
            </div>

            {/* Team Links */}
            <div className="space-y-4">
              <h4 className="text-lg font-semibold text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-yellow-300">
                Notre Équipe
              </h4>
              <ul className="space-y-2">
                <li><a href="#leadership" className="text-gray-300/80 hover:text-amber-300 transition-colors duration-200 text-sm hover:drop-shadow-lg">Direction & Leadership</a></li>
                <li><a href="#experts" className="text-gray-300/80 hover:text-amber-300 transition-colors duration-200 text-sm hover:drop-shadow-lg">Experts & Consultants</a></li>
                <li><a href="#culture" className="text-gray-300/80 hover:text-amber-300 transition-colors duration-200 text-sm hover:drop-shadow-lg">Culture & Valeurs</a></li>
                <li><a href="#careers" className="text-gray-300/80 hover:text-amber-300 transition-colors duration-200 text-sm hover:drop-shadow-lg">Opportunités Carrière</a></li>
              </ul>
            </div>

            {/* Expertise */}
            <div className="space-y-4">
              <h4 className="text-lg font-semibold text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-yellow-300">
                Expertise Collective
              </h4>
              <ul className="space-y-2">
                <li><a href="/ai-solutions-integration-hub" className="text-gray-300/80 hover:text-amber-300 transition-colors duration-200 text-sm hover:drop-shadow-lg">Intelligence Artificielle</a></li>
                <li><a href="/digital-marketing-services" className="text-gray-300/80 hover:text-amber-300 transition-colors duration-200 text-sm hover:drop-shadow-lg">Marketing Digital</a></li>
                <li><a href="/human-resources-management-services" className="text-gray-300/80 hover:text-amber-300 transition-colors duration-200 text-sm hover:drop-shadow-lg">Ressources Humaines</a></li>
                <li><a href="/digital-project-management-services" className="text-gray-300/80 hover:text-amber-300 transition-colors duration-200 text-sm hover:drop-shadow-lg">Projets Numériques</a></li>
              </ul>
            </div>

            {/* Contact */}
            <div className="space-y-4">
              <h4 className="text-lg font-semibold text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-yellow-300">
                Contactez l'Équipe
              </h4>
              <div className="space-y-3">
                <a href="/consultation" className="flex items-center space-x-2 text-gray-300/80 hover:text-amber-300 transition-colors duration-200 text-sm hover:drop-shadow-lg">
                  <Icon name="MessageSquare" size={16} />
                  <span>Consultation Équipe</span>
                </a>
                <a href="tel:+229" className="flex items-center space-x-2 text-gray-300/80 hover:text-amber-300 transition-colors duration-200 text-sm hover:drop-shadow-lg">
                  <Icon name="Phone" size={16} />
                  <span>+229 XX XX XX XX</span>
                </a>
                <a href="mailto:team@crfperfection.com" className="flex items-center space-x-2 text-gray-300/80 hover:text-amber-300 transition-colors duration-200 text-sm hover:drop-shadow-lg">
                  <Icon name="Mail" size={16} />
                  <span>team@crfperfection.com</span>
                </a>
                <a href="/careers" className="flex items-center space-x-2 text-gray-300/80 hover:text-amber-300 transition-colors duration-200 text-sm hover:drop-shadow-lg">
                  <Icon name="Briefcase" size={16} />
                  <span>Rejoindre l'Équipe</span>
                </a>
              </div>
            </div>
          </div>

          {/* Bottom Footer */}
          <div className="border-t border-amber-500/20 mt-12 pt-8">
            <div className="flex flex-col md:flex-row items-center justify-between">
              <p className="text-sm text-gray-400/90 mb-4 md:mb-0">
                © 2024 CRF Perfection - Notre Équipe. L'excellence par la collaboration humaine.
              </p>
              <div className="flex space-x-6">
                <a href="/privacy" className="text-sm text-gray-400/80 hover:text-amber-300 transition-colors duration-200 hover:drop-shadow-lg">Confidentialité</a>
                <a href="/terms" className="text-sm text-gray-400/80 hover:text-amber-300 transition-colors duration-200 hover:drop-shadow-lg">Conditions</a>
                <a href="/careers" className="text-sm text-gray-400/80 hover:text-amber-300 transition-colors duration-200 hover:drop-shadow-lg">Carrières</a>
              </div>
            </div>
          </div>
        </div>

        {/* Decorative Elements */}
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-gradient-to-t from-amber-500/5 to-transparent rounded-full blur-3xl pointer-events-none"></div>
        <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-b from-[#9B8E56]/5 to-transparent rounded-full blur-3xl pointer-events-none"></div>
      </footer>
    </>
  );
};

export default CTASection;